import SoftBadge from "modules/common/SoftBadge";
import React from "react";

function UserComponent({ segmentData }) {
  return (
    <div>
      <div className="d-flex flex-row gap-1 flex-wrap mt-4">
        <div className="d-flex align-items-center">
          <span className="fw-bold">Customer Type :</span>{" "}
          <SoftBadge bg="primary" className="ms-2">
            <span style={{ fontSize: "12px" }}>
              {" "}
              {segmentData?.customerType}
            </span>
          </SoftBadge>
          <span className="mx-2 fw-bold">|</span>
        </div>
        <div className="d-flex align-items-center">
          <span className="fw-bold">Customer Slug :</span>{" "}
          <SoftBadge bg="primary" className="ms-1">
            <span>{segmentData?.cutomerSlug}</span>
          </SoftBadge>
          <span className="mx-2 fw-bold">|</span>
        </div>
        <div className="d-flex align-items-center">
          <span className="fw-bold">Running Month For Hair Kit :</span>{" "}
          <SoftBadge bg="primary" className="ms-1">
            <span style={{ fontSize: "12px" }}>
              {" "}
              {segmentData?.runningMonthForHairKit}
            </span>
          </SoftBadge>
          <span className="mx-2 fw-bold">|</span>
        </div>
        <div className="d-flex align-items-center">
          <span className="fw-bold">Running Week in Month For Hair Kit:</span>{" "}
          <SoftBadge bg="primary" className="ms-1">
            {segmentData?.runningWeekinMonthForHairKit}
          </SoftBadge>
        </div>
      </div>
      <hr className="fw-bold"></hr>
      <div className="mt-3" style={{marginTop:"3rem"}}>
        <div className="d-flex border border-2 rounded bg-secondary  text-white">
          <div className="flex-1 border-end fw-bold p-2">Display Title</div>
          <div className="flex-1 p-2 fw-bold">Slug</div>
        </div>
        {segmentData?.component?.map((item, index) => {
          const dataLength = segmentData?.component.length-1;
          return (
            <div className={index==dataLength?"d-flex border border-2 rounded text-secondary hover-bg-primary":"d-flex border border-bottom-0 border-2 text-secondary hover-bg-primary"}>
              <div className="flex-1 p-2 border-end">
               <span className=" fw-bold">{item?.display_title}!</span>{" "}
              </div>
              <div className="flex-1 p-2">
               <span className="text-black">{item?.slug}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default UserComponent;
